module.exports = __webpack_public_path__ + "5951931148965a09cacfd8b5e7f5c981.png";